import {
  STOREFRONT_SUB_MODULES,
  TENANT_MODULE_DEFAULTS,
  TENANT_MODULE_KEYS,
  type TenantModuleKey,
  type TenantModules,
} from "@loot-os/api-contract";

/**
 * The modules as the form lays them out: each top-level module, with the storefront's own
 * nested beneath it (shown disabled while the storefront is off).
 */
export const TENANT_MODULE_FORM: readonly {
  key: TenantModuleKey;
  children: readonly TenantModuleKey[];
}[] = TENANT_MODULE_KEYS.filter(
  (key) => !(STOREFRONT_SUB_MODULES as readonly string[]).includes(key),
).map((key) => ({ key, children: key === "storefront" ? STOREFRONT_SUB_MODULES : [] }));

/** A fresh tenant's form: every module on, which is also what an untouched `{}` means. */
export function defaultTenantModules(): TenantModules {
  return { ...TENANT_MODULE_DEFAULTS };
}

/**
 * A percent as staff type it ("12.5", "12.5%") to basis points, or null when it is not a number
 * from 0 to 100 with at most two decimals. "" is 0%.
 */
export function percentToBps(text: string): number | null {
  const trimmed = text.trim().replace(/%$/, "").trim();
  if (trimmed === "") return 0;
  if (!/^\d{1,3}(\.\d{1,2})?$/.test(trimmed)) return null;
  const bps = Math.round(Number(trimmed) * 100);
  return bps <= 10_000 ? bps : null;
}

/** Basis points as the percent input shows them: 1250 → "12.5". */
export function bpsToPercentText(bps: number): string {
  return String(Number((bps / 100).toFixed(2)));
}
